import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axioKit } from "../../../../utilities";

const url = "/diagnostics/clinic/supplies";

const blankItem = () => ({
  menu: "",
  batchNo: "",
  expiry: "",
  qnty: 1,
  unit: "pcs",
  remarks: "",
});

const initialState = {
  showModal: false,
  activeStep: 0,
  formSubmitted: false,
  isSuccess: false,
  message: "",
  form: {
    clinic: "",
    supplier: "",
    remarks: "",
    status: "draft",
    items: [],
  },
};

export const SAVE = createAsyncThunk(`${url}/save`, ({ data, token }, thunkAPI) => {
  try {
    return axioKit.save(url, data, token);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();

    return thunkAPI.rejectWithValue(message);
  }
});

export const reduxSlice = createSlice({
  name: "clinicSupplies",
  initialState,
  reducers: {
    SetCREATE: (state, { payload }) => {
      state.showModal = true;
      state.activeStep = 0;
      state.message = "";
      state.isSuccess = false;
      state.form = {
        clinic: payload?.clinic || "",
        supplier: "",
        remarks: "",
        status: "draft",
        items: [],
      };
    },
    toggleModal: (state) => {
      state.showModal = !state.showModal;
      state.activeStep = 0;
      state.message = "";
      if (!state.showModal) {
        state.form = initialState.form;
      }
    },
    SetStep: (state, { payload }) => {
      state.activeStep = Math.max(0, Number(payload || 0));
    },
    SetFormValue: (state, { payload }) => {
      state.form[payload?.key] = payload?.value;
    },
    AddItem: (state, { payload }) => {
      state.form.items.push(payload || blankItem());
    },
    RemoveItem: (state, { payload }) => {
      if (state.form.items.length === 1) return;
      state.form.items = state.form.items.filter((_, index) => index !== payload);
    },
    SetItemValue: (state, { payload }) => {
      const { index, key, value } = payload || {};
      if (!state.form.items[index]) return;
      state.form.items[index][key] = value;
    },
    RESET: (state) => {
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SAVE.pending, (state) => {
        state.formSubmitted = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(SAVE.fulfilled, (state, action) => {
        state.formSubmitted = false;
        state.isSuccess = true;
        state.message = action.payload?.success || "";
        state.showModal = false;
        state.activeStep = 0;
        state.form = initialState.form;
      })
      .addCase(SAVE.rejected, (state, action) => {
        state.formSubmitted = false;
        state.isSuccess = false;
        state.message = action.payload || action.error?.message || "";
      });
  },
});

export const {
  SetCREATE,
  toggleModal,
  SetStep,
  SetFormValue,
  AddItem,
  RemoveItem,
  SetItemValue,
  RESET,
} = reduxSlice.actions;

export default reduxSlice.reducer;
